import { render, staticRenderFns } from "./program-unit-attendances.vue?vue&type=template&id=18e68ae6&"
import script from "./program-unit-attendances.vue?vue&type=script&lang=js&"
export * from "./program-unit-attendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports